import React from 'react';
import classNames from 'classnames';

import css from './IconOvenFill.module.css';

/**
 * IconOvenFill icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconOvenFill = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_2509_4240)">
<path d="M21.8002 0.239746H2.20024C1.11775 0.239746 0.240234 1.11726 0.240234 2.19975V21.7997C0.240234 22.8823 1.11773 23.7598 2.20024 23.7597H21.8002C22.8827 23.7598 23.7602 22.8823 23.7602 21.7997V2.19975C23.7602 1.11726 22.8827 0.239746 21.8002 0.239746ZM17.3902 3.17975C18.5218 3.17975 19.2291 4.40475 18.6633 5.38475C18.0975 6.36474 16.683 6.36474 16.1172 5.38475C15.9882 5.16127 15.9202 4.90778 15.9202 4.64975C15.9202 3.83789 16.5784 3.17975 17.3902 3.17975ZM12.0002 3.17975C13.1318 3.17975 13.8391 4.40475 13.2733 5.38475C12.7075 6.36474 11.293 6.36474 10.7272 5.38475C10.5982 5.16127 10.5302 4.90778 10.5302 4.64975C10.5302 3.83789 11.1884 3.17975 12.0002 3.17975ZM6.61024 3.17975C7.74184 3.17975 8.4491 4.40475 7.8833 5.38475C7.31749 6.36474 5.90298 6.36474 5.33718 5.38475C5.20816 5.16127 5.14024 4.90778 5.14024 4.64975C5.14024 3.83789 5.79838 3.17975 6.61024 3.17975ZM19.8402 19.8397H4.16023V9.05975H19.8402V19.8397Z" fill="#262338"/>
</g>
<defs>
<clipPath id="clip0_2509_4240">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};

export default IconOvenFill;
